"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading4 = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const H4 = styled_components_1.default.span `
	display: block;
	color: ${(p) => p.theme.palette.text.eyebrow || p.theme.palette.text.secondary || p.theme.palette.text.primary};
	letter-spacing: 3px;
	text-transform: uppercase;

	/* make sure to override account-management */
	&.h4 {
		margin: 0;
		font-size: 13px;
		font-family: ${(p) => p.theme.fonts.heading4 || p.theme.fonts.default};
		font-weight: 500;
		line-height: 18px;
	}
`;
const Heading4 = ({ children }) => {
    return react_1.default.createElement(H4, { className: "h4" }, children);
};
exports.Heading4 = Heading4;
//# sourceMappingURL=Heading4.atom.js.map